"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SINGLE_PAY_FACE_AMOUNT_FACTOR = void 0;
exports.SINGLE_PAY_FACE_AMOUNT_FACTOR = 1.001;
//# sourceMappingURL=standard-factors.js.map